import { useEffect, useState, useCallback } from 'react'

const useOpenIds = (initialOpenIds) => {
  const [openIds, setOpenIds] = useState([])

  useEffect(() => {
    if (initialOpenIds) {
      setOpenIds(initialOpenIds)
    }
  }, [initialOpenIds])

  const handleToggle = useCallback(
    (targetId) => {
      if (openIds.includes(targetId)) {
        return setOpenIds(openIds.filter((id) => id !== targetId))
      }
      return setOpenIds([...openIds, targetId])
    },
    [openIds],
  )

  return { openIds, handleToggle }
}

export default useOpenIds
